// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2azYE","label":"Labeled_label__3GcBo","divider":"Labeled_divider__3L6XZ"};